// Reusable Edge grading primitives for the "tap the location" response type.
//
// Everything here works in DATA coordinates, never pixels:
//   x = slot on the chart (candle index / time slot)
//   y = price
// A tap is stored as { x, y } in those units, so grading gives the same answer
// at any screen size and can later be reproduced on the server. A later Read
// (swing highs, support/resistance, invalidation areas) only has to describe its
// correct zones in the same units to reuse the interaction unchanged.
//
// A zone is an array of rects; a tap anywhere inside any rect is correct.
//   rect: { x: [min, max], y: [min, max] }

export const inRect = (pt, rect) =>
  !!pt &&
  pt.x >= rect.x[0] &&
  pt.x <= rect.x[1] &&
  pt.y >= rect.y[0] &&
  pt.y <= rect.y[1];

export const hitsZone = (pt, zone) => !!pt && zone.some((rect) => inRect(pt, rect));

// Grades every prompt against its own zone. Prompts are graded independently,
// so two prompts may share a zone (e.g. Open and Low on a candle with no lower
// wick) and one tap location can be correct for each of them.
export function gradeAnswers(prompts, answers) {
  const byId = {};
  prompts.forEach((p) => {
    byId[p.id] = { correct: hitsZone(answers[p.id], p.zone), answer: answers[p.id] || null };
  });
  return { byId, allCorrect: prompts.every((p) => byId[p.id].correct) };
}
